module.exports = __webpack_public_path__ + "img/icon-nav1.abcca13e.svg";